export const numberFormat: (number: number) => string = (number: number) => {
    const formatter = new Intl.NumberFormat('en', {minimumFractionDigits: 0, maximumFractionDigits: 0});
    return formatter.format(number);
}